import { Badge } from "./ui/badge";

const gradeColor = (g) => {
  const s = String(g).toUpperCase();
  if (["A*", "A", "9", "8"].includes(s)) return "text-emerald-500";
  if (["B", "C", "7", "6", "5"].includes(s)) return "text-amber-500";
  return "text-rose-400";
};

export const QuestionResult = ({ r }) => (
  <div className="rounded-3xl border border-border bg-card p-6" data-testid={`result-question-${r.number}`}>
    <div className="flex items-center justify-between mb-4">
      <span className="font-semibold font-display">Question {r.number}</span>
      <Badge className="bg-primary/15 text-primary hover:bg-primary/15">{r.marks_awarded}/{r.marks_available} marks</Badge>
    </div>
    <p className="text-sm leading-relaxed mb-4">{r.justification}</p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="rounded-2xl bg-emerald-500/10 p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-500 mb-2">Strengths</p>
        <ul className="text-xs space-y-1.5 text-muted-foreground list-disc pl-4">{(r.strengths || []).map((s, j) => <li key={j}>{s}</li>)}</ul>
      </div>
      <div className="rounded-2xl bg-rose-500/10 p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-rose-400 mb-2">Weaknesses</p>
        <ul className="text-xs space-y-1.5 text-muted-foreground list-disc pl-4">{(r.weaknesses || []).map((s, j) => <li key={j}>{s}</li>)}</ul>
      </div>
      <div className="rounded-2xl bg-indigo-500/10 p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-2">Improvements</p>
        <ul className="text-xs space-y-1.5 text-muted-foreground list-disc pl-4">{(r.improvements || []).map((s, j) => <li key={j}>{s}</li>)}</ul>
      </div>
    </div>
    {r.mark_scheme_comparison && (
      <p className="mt-4 text-xs text-muted-foreground rounded-2xl bg-secondary p-4"><span className="font-semibold">Mark scheme comparison: </span>{r.mark_scheme_comparison}</p>
    )}
  </div>
);

export const MarkingResults = ({ result }) => (
  <div className="space-y-6" data-testid="marking-results">
    <div className="rounded-3xl border border-border bg-card p-8 flex flex-col md:flex-row items-start md:items-center gap-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Notional paper grade</p>
        <p className={`text-6xl font-bold font-display ${gradeColor(result.estimated_grade)}`} data-testid="estimated-grade">{result.estimated_grade}</p>
        {result.grade_info?.label && (
          <p className="text-[11px] text-muted-foreground mt-1.5 max-w-[240px] leading-snug" data-testid="grade-basis-label">{result.grade_info.label}</p>
        )}
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Score</p>
        <p className="text-3xl font-bold font-display">{result.total_awarded}/{result.total_available} <span className="text-lg text-muted-foreground">({result.percentage}%)</span></p>
        {result.time_taken_minutes ? <p className="text-xs text-muted-foreground mt-1">Completed in {result.time_taken_minutes} min</p> : null}
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed md:ml-auto md:max-w-md">{result.overall_feedback}</p>
    </div>

    {result.grade_info?.disclaimer && (
      <p className="text-xs text-muted-foreground rounded-2xl bg-secondary px-4 py-3" data-testid="grade-disclaimer">{result.grade_info.disclaimer}</p>
    )}

    {result.results.map((r, i) => <QuestionResult key={i} r={r} />)}
  </div>
);
